<template>
    <div :class="wrapperClass">
        <progress-spinner :style="spinnerStyle"
                          style="width: 30px;height: 30px;"
                          stroke-width="5"
                          class="m-auto"
        />
    </div>
</template>

<script>
export default {
    name: 'LoadingSpinner',

    props: {
        wrapperClass: {
            type: String,
            default: 'flex'
        },
        color: {
            type: String,
            default: 'primary'
        }
    },

    computed: {
        spinnerStyle() {
            return {
                '--p-progressspinner-color-one': `var(--${this.color}-color)`,
                '--p-progressspinner-color-two': `var(--${this.color}-color)`,
                '--p-progressspinner-color-three': `var(--${this.color}-color)`,
                '--p-progressspinner-color-four': `var(--${this.color}-color)`
            };
        }
    }
}
</script>
